import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdLeaderboard } from 'react-icons/md';
import { PiCity } from 'react-icons/pi';
import { IoLocationSharp } from 'react-icons/io5';
import { FaMapLocationDot } from 'react-icons/fa6';

interface Visit {
  id: string;
  ipAddress: string;
  city: string;
  latitude: number;
  longitude: number;
  visitedAt: string;
}

interface LocationState {
  state: {
    visit: Visit;
    propertyId: string;
  };
}

const UserLeads = () => {
  const location = useLocation() as LocationState;

  const visit = location.state?.visit;

  console.log(visit)
  const propertyId = location.state.propertyId;
  const navigate = useNavigate();
  const BackToProperties = () => {
    navigate(`/property/${propertyId}`);
  };
  return (
    <>
      <Container fluid className="p-4">
        <div className="container-small">
          <Row className="g-5 mb-5 mb-lg-4 ">
            <Col>
              <Card>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="fw-bold mb-0">Leads Details</h3>
                    <Button
                      className="btn btn-primary px-5 w-md-auto ms-4"
                      style={{ marginRight: '18px' }}
                      onClick={BackToProperties}
                    >
                      Back
                    </Button>
                  </div>

                  {visit ? (
                    <div className="mb-4 mt-4 border rounded p-3 shadow-sm bg-white">
                      <Row className="align-items-center">
                        <Col
                          xs={12}
                          sm={2}
                          className="text-center mb-3 mb-sm-0"
                        >
                          <MdLeaderboard /> Leads <br />
                        </Col>

                        <Col xs={12} sm={7}>
                          <div>
                            <PiCity /> IP Address: {visit.ipAddress}
                          </div>
                          <div>
                            <IoLocationSharp /> Location: {visit.city}
                          </div>
                          <div>
                            <FaMapLocationDot /> Latitude: {visit.latitude},{' '}
                            <FaMapLocationDot /> Longitude: {visit.longitude}
                          </div>
                        </Col>

                        <Col
                          xs={12}
                          sm={3}
                          className="text-sm-end mt-3 mt-sm-0"
                        >
                          <div className="text-muted mt-1">
                            <i className="bi bi-calendar-event me-1" />
                            {new Date(visit.visitedAt).toLocaleString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: 'numeric',
                              minute: '2-digit',
                              hour12: true
                            })}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: '100px' }}
                    >
                      <h5 className="text-danger">No data found</h5>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default UserLeads;
